var $ab5183739b6c5e7e$exports = {};
$ab5183739b6c5e7e$exports = {
  "removeButtonLabel": "Pa\u0161alinti",
  "removeDescription": "Nor\u0117dami pa\u0161alinti \u017Eym\u0105, paspauskite \u201EDelete\u201C klavi\u0161\u0105."
};
export { $ab5183739b6c5e7e$exports as default };